import React from 'react';
import { motion } from 'framer-motion';

const Payment = () => {
  return (
    <section id="payment" className="py-20" style={{backgroundColor: '#F8E84A'}}>
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-league-spartan font-bold text-black mb-6">
            Formas de <span className="text-red-primary">Pago</span>
          </h2>
          <div className="w-24 h-1 bg-red-primary mx-auto mb-8"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            <img 
              src="/set/6.png" 
              alt="Formas de pago" 
              className="w-2/3 h-auto rounded-2xl mx-auto"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <p className="text-lg text-gray-700 leading-relaxed">
              Al momento de inscribirte se te dará el dato de la cuenta de ahorro de Banco Agrícola para que hagas tu transferencia por el monto indicado.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              La fecha de tu primera transferencia se convertirá en tu fecha de pago en adelante.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Pero no te preocupes, tu Asesora Personalizada te hará el recordatorio correspondiente antes de tu fecha de pago para los meses siguientes.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Payment;